// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"16c7445d","453":"71965dad","934":"e50b8216"}[chunkId] + ".chunk.js";
};